
import  WindowCoordinates  from './WindowCoordinates';
import { ElementCoordinate } from '../enums/enums';

class LocatePopup {
    triggerBoundingRectangle:DOMRect;
    popupBoundingRectangle:DOMRect;
    popupLocation:ElementCoordinate;
    popupOffsetPx:number;
    popup:HTMLDivElement;
    _point: {xPx:string, yPx:string};
	constructor(triggerBoundingRectangle:DOMRect, popup:HTMLDivElement, popupBoundingRectangle:DOMRect, popupLocation:ElementCoordinate )
    {
		this.triggerBoundingRectangle = triggerBoundingRectangle;
		this.popupBoundingRectangle = popupBoundingRectangle;
		this.popupLocation = popupLocation;
		this.popupOffsetPx = 5;				//disabled message offset (applies to uc, cl, cr and lc)
        this.popup = popup;
        this._point = {xPx:"0", yPx:"0"};
		//this.removePreviousPopupLeftAndTop();
		this.populatePositionLeftTop();
	}

	removePreviousPopupLeftAndTop(){
		this.popup.style.removeProperty("left");
		this.popup.style.removeProperty("top");
	}

    getLocation(){
        return this._point;
    }

	populatePositionLeftTop(){
		const triggerTopWithScroll = new WindowCoordinates(this.triggerBoundingRectangle, ElementCoordinate.UpperCenter).getPoint().y;
		const triggerBottomWithScroll = new WindowCoordinates(this.triggerBoundingRectangle, ElementCoordinate.LowerCenter).getPoint().y;
		const triggerLeft = this.triggerBoundingRectangle.left;
		const triggerRight = this.triggerBoundingRectangle.right;
		const triggerWidth = this.triggerBoundingRectangle.width;
		const triggerHeight = this.triggerBoundingRectangle.height;
		const popupWidth = this.popupBoundingRectangle.width;
		const popupHeight = this.popupBoundingRectangle.height; 
		
		switch(this.popupLocation){
			case ElementCoordinate.UpperLeft:
				this._point.xPx = triggerLeft - popupWidth + "px";
				this._point.yPx = triggerTopWithScroll - popupHeight + "px";
			break;
			case ElementCoordinate.UpperCenter:
				this._point.xPx = triggerLeft + (triggerWidth * .5) - (popupWidth * .5) + "px";
				this._point.yPx = triggerTopWithScroll - this.popupOffsetPx - popupHeight + "px";
				break;
			case ElementCoordinate.UpperRight:
				this._point.xPx = triggerLeft + triggerWidth + "px";
				this._point.yPx = triggerTopWithScroll - popupHeight + "px";			
			break;
			case ElementCoordinate.CenterLeft:
				this._point.xPx = triggerLeft - this.popupOffsetPx  - popupWidth + "px";
				this._point.yPx = triggerBottomWithScroll - (triggerHeight * .5) - (popupHeight * .5) + "px";
			break;
			case ElementCoordinate.CenterRight:
				this._point.xPx = triggerRight + this.popupOffsetPx + "px";
				this._point.yPx = triggerBottomWithScroll - (triggerHeight * .5) - (popupHeight * .5) + "px";
			break;
			case ElementCoordinate.LowerLeft:
				this._point.xPx = triggerLeft - popupWidth + "px";
				this._point.yPx = triggerBottomWithScroll + "px";
			break;
			case ElementCoordinate.LowerCenter:
				this._point.xPx = triggerLeft + (triggerWidth * .5) - (popupWidth * .5) + "px";
				this._point.yPx = triggerBottomWithScroll + this.popupOffsetPx + "px";
			break;

			case ElementCoordinate.LowerRight:
				this._point.xPx = triggerRight + "px";
				this._point.yPx = triggerBottomWithScroll + "px";
			break;

			case ElementCoordinate.MobileAbove:
				this._point.xPx = ((document.documentElement.clientWidth - popupWidth) * .5) + "px";
				this._point.yPx = triggerTopWithScroll - this.popupOffsetPx - popupHeight + "px";
			break;

			case ElementCoordinate.MobileBelow:
				this._point.xPx = ((document.documentElement.clientWidth - popupWidth) * .5) + "px";
				this._point.yPx = triggerBottomWithScroll + this.popupOffsetPx + "px";
			break;
		}
	}
}

export default LocatePopup;